import {postActionManage,httpActionManage,putActionManage,getActionManage,deleteActionManage,ajaxGetDictItemsManage} from '@/api/manageCommon'


export const serviceUrl = process.env.VUE_APP_CLOUD_URL;


//post
export function postAction(url, parameter) {
    return postActionManage(serviceUrl,url, parameter)
}

//post method= {post | put}
export function httpAction(url, parameter, method) {
    return httpActionManage(serviceUrl,url, parameter, method)
}

//put
export function putAction(url, parameter) {
    return putActionManage(serviceUrl,url, parameter)
}

//get
export function getAction(url, parameter) {
    return getActionManage(serviceUrl,url, parameter)
}

//deleteAction
export function deleteAction(url, parameter) {
    return deleteActionManage(serviceUrl,url, parameter)
}

//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => ajaxGetDictItemsManage(serviceUrl,`/sys/dict/getDictItems/${code}`, params);


/**
 * 获取字典数组
 * @param dictCode 字典Code
 * @return List<Map>
 */
export async function initDictOptions(dictCode) {
    if (!dictCode) {
        return '字典Code不能为空!';
    }
    //获取字典数组
    let res = await ajaxGetDictItems(dictCode);
    return res;
}

/**
 * 翻译字段值对应的文本
 * @param children
 * @returns string
 */
export async function filterDictText(dictCode, key) {
    if (key == null || key.length == 0) {
        return;
    }
    if (!dictCode) {
        return '字典Code不能为空!';
    }
    /* //优先从缓存中读取字典配置
  if(initDictOptions(dictCode)){
	  
  } */
    var res = await initDictOptions(dictCode);
    return res
}

